import api from './api';

export const getSalesTrends = async (period = 'monthly') => {
  const response = await api.get(`/analytics/sales-trends?period=${period}`);
  return response.data;
};

export const getPerformanceData = async (type, limit = 10) => {
  const response = await api.get(`/analytics/performance/${type}?limit=${limit}`);
  return response.data;
};
